import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";

import Layout from "../../Components/Layout/Layout";
import ChildHelps from "./Components/ChildHelps";
import TopBanner from "./Components/TopBanner";
import ParticipateFlow from "./Components/ParticipateFlow";
import DetailTabs from "./Components/DetailTabs";

import { getCateoryList, getEventByName, getEventProps, resetEventDetails } from "../../redux/actions/event";

const ProgramDetail = () => {

  const dispatch = useDispatch();

  const { event_code } = useParams();

  const eventDetails = useSelector(state => state.event.eventDetails);
  const eventProps = useSelector(state => state.event.eventProps);
  const categoryList = useSelector(state => state.event.categoryList);
  const activityList = useSelector(state => state.event.activityList);

  const ageRange = eventDetails?.filter?.filter_type === "Age" ? eventDetails?.filter?.filter_range : [];
  const classRange = eventDetails?.filter?.filter_type === "Class" ? eventDetails?.filter?.filter_range : [];
  const initAge = ageRange?.length ? `${ageRange?.[0]?.minimum}-${ageRange?.[0]?.maximum}` : null;
  const initClass = classRange?.length ? `${classRange?.[0]?.minimum}-${classRange?.[0]?.maximum}` : null;

  const [categoryId, setCategoryId] = useState()

  useEffect(() => {
    dispatch(getEventByName({ eventCode: event_code }, data => {
      const { event_id } = data
      dispatch(getEventProps({ event_id }));
      dispatch(getCateoryList({ competition_id: event_id, page_number: 0, page_size: 100 }, id => {
        setCategoryId(id)
      }))
    }));
    return () => dispatch(resetEventDetails());
  }, [])

  return (
    <Layout page="learningPrograms" title="Learning Programs">
      <div className="wrapper champion-landing-wrapper">
        <TopBanner data={eventDetails} eventProps={eventProps} />
        {categoryId && <DetailTabs
          categoryList={categoryList}
          activityList={activityList}
          setCategoryId={setCategoryId}
          categoryId={categoryId}
          event_id={eventDetails?.event_id}
          eventDetails={eventDetails}
          ageGrp={initAge}
          classGrp={initClass}
          ageRange={ageRange}
          classRange={classRange}
        />}
        <div className="competitions-content px-4">
          <div className="chmpn-container">
            <div className="chmp-pricipate-flow context_narchome">
              <div className="chmpn-main-hdng text-center">
                <h3 className="main-hdng-title" id="chmp-participate">How to participate in Championships ?</h3>
              </div>
              <ParticipateFlow eventCode={event_code} />
            </div>
          </div>
        </div>
        <div className="competitions-content px-4">
          <div className="chmpn-container">
            <div className="narcLand my-5">
              <div className="chmpn-main-hdng text-center">
                <h3 className="main-hdng-title">How do KidEx Championships helps in holistic child development?</h3>
              </div>
              <ChildHelps />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ProgramDetail;
